// let url_config = "https://uat.zd-ehome.com/ehome-api-service";
let url_config = "https://myd0755.com/ehome-api-service"
// let url_config = "http://localhost:8081/ehome-api-service"
let url_renovation = "http://localhost:3000"


export var urlRenovation = url_renovation
export default url_config;
